import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../../actions/galleryActions.js';
import _ from 'lodash';
import {utils} from '../../utils'
import {logger} from '../../utils'

export class MultishareContainer extends React.Component {
  constructor(props, context) {
    super(props, context);

    console.log("Multishare loaded");

    this.state = {
      items: [],
      itemsDOM: this.createItems([]),
      top: 0
    };

    this.itemHeight = this.itemWidth = (utils.isMobile() ? 12 : 62);


    this.hashtag = '';
    this.shareButtons = [];

    this.clearMultishareItems = this.clearMultishareItems.bind(this);
    this.scroll = this.scroll.bind(this);
    this.resetWidgetPosition = this.resetWidgetPosition.bind(this);
    this.resetWidgetPosition = _.throttle(this.resetWidgetPosition, 1000).bind(this);

  }

  //------------------------------------------| INIT |--------------------------------------------//

  initPubsubListener() {

    this.pubsubListener = (event) => {
      console.log('multishare pubsub', event);
      var data = event.data;
      if (_.isString(data.call) && _.isFunction(this[data.call]) && _.isObject(data.data)) {
        this[data.call](data.data)
      }
    };

    var PubSub = Wix.PubSub || Wix.Worker.PubSub;
    PubSub.subscribe("gallery2multishare", this.pubsubListener);
  }

  removePubsubListener() {
    var PubSub = Wix.PubSub || Wix.Worker.PubSub;
    PubSub.unsubscribe("gallery2multishare", this.pubsubListener);
  }

  //-----------------------------------------| ACTIONS |------------------------------------------//

  addItemToMultishare(itemDto) {

    //gets called via pubsub

    console.log("HASHTAG - Adding item", itemDto);

    var multishareItems = this.state.items.concat([itemDto]);

    multishareItems = _.uniqBy(multishareItems, (item) => item.id);

    console.log('New multishareItems', multishareItems);

    if (multishareItems.length > 0) {
      // this.createInitialHashtagIfNeeded(multishareItems);
      this.shareButtons = this.createShareButton(multishareItems)
    }

    this.toggleMultishareBar(multishareItems.length !== 0);

    if (utils.browserIs('safari')) {
      setTimeout(() => {
        utils.setStateAndLog(this, 'HASHTAG - addItemToMultishare (safari)', {
          items: multishareItems,
          itemsDOM: this.createItems(multishareItems)
        }, () => {
          var sel = document.body;
          sel.style.display = 'none';
          sel.offsetHeight; // no need to store this anywhere, the reference is enough
          sel.style.display = '';
        });
      }, 100);
    } else {
      utils.setStateAndLog(this, 'HASHTAG - addItemToMultishare', {
        items: multishareItems,
        itemsDOM: this.createItems(multishareItems)
      });
    }

    Wix.PubSub.publish("multishare2gallery", {update: true, items: _.map(multishareItems, (item) => {
      return {id: item.id}
    })}, true);

    logger.track('select_photo', {
        num_of_item_in_group: multishareItems.length,
        group_size: multishareItems.length,
        value: 'choose'
    })
  }

  removeItemFromMultishare(itemDto) {

    console.log("HASHTAG - Removing item", itemDto);

    var multishareItems = this.state.items;

    multishareItems = _.filter(multishareItems, (item) => {
      return (
        (item.itemId || item.photoId) != (itemDto.itemId || itemDto.photoId)
      );
    });

    utils.setStateAndLog(this, 'HASHTAG - removeItemFromMultishare', {
      items: multishareItems,
      itemsDOM: this.createItems(multishareItems)
    });
    this.toggleMultishareBar(multishareItems.length !== 0);
    Wix.PubSub.publish("multishare2gallery", {update: true, items: multishareItems}, true);

    logger.track('select_photo', {
      num_of_item_in_group: multishareItems.length,
      group_size: multishareItems.length,
      value: 'unchoose'
    })

  }

  clearMultishareItems() {

    utils.setStateAndLog(this, 'clearMultishareItems', {
      items: [],
      itemsDOM: this.createItems([])
    });
    this.hideMultishareBar(false);
    Wix.PubSub.publish("multishare2gallery", {update: true, items: []}, true);

  }

  isMultisharing() {
    return !!this.state.items.length
  }

  //------------------------------------------| UTILS |-------------------------------------------//

  createShareButton(items) {

    if (items.length == 0) {
      return [];
    }

    var openDialogButton = [
      <span className={"dialog-share-number"}
         key={"dialog-share-number"}>{items.length}</span>,
      <i className={"dialog-share progallery-svg-font-icons-share_bar"}
         onClick={() => this.openDialog(items)}
         key={"dialog-share-icon"}/>
    ];

    return openDialogButton;
  }

  getTextDimensions(item) {

    var itemHeight = this.itemHeight;
    var itemWidth = (item.style.width / item.style.height) * itemHeight;

    //text dimensions include scaling
    var transform = 'translate(0, 0) scale(' + ((item.style.width < (item.style.height + 1)) ? (itemHeight / item.style.maxHeight) : (itemWidth / item.style.maxWidth)) + ')';
    return {
      margin: (Math.floor((item.style.maxHeight - itemHeight) / -2)) + 'px ' + (Math.floor((item.style.maxWidth - itemWidth) / -2)) + 'px',
      width: item.style.maxWidth + 'px',
      height: item.style.maxHeight + 'px',
      WebkitTransform: transform,
      MsTransform: transform,
      OTransform: transform,
      transform: transform,
    };

  }

  createItems(itemsDto) {

    if (utils.isMobile()) {
      return [];
    }

    var itemsDom = [];
    itemsDto.forEach((item) => {
      itemsDom.push(
        item.type == 'text' ? (
          <div
            className="sharer-item"
            key={`sharer-item-${item.id}`}
            style={{
              'backgroundColor': item.style.bgColor
            }}>
            <i className="sharer-item-x progallery-svg-font-icons-x"
               onClick={() => this.removeItemFromMultishare(item)}/>
            <div className="sharer-item-text" dangerouslySetInnerHTML={{__html: item.html}} style={this.getTextDimensions(item)}/>
          </div>
        ) : (
          <div
            className="sharer-item"
            key={`sharer-item-${item.id}`}
          >
            <i className="sharer-item-x progallery-svg-font-icons-x"
               onClick={() => this.removeItemFromMultishare(item)}/>
            <img src={item.resized_url['img']} alt=""/>
          </div>
        )
      );
    });

    return itemsDom;
  }

  setActiveIframe() {
    //this method is used to make sure only one multishare iframe is active (in case several widget were added)
    const worker = utils.getWorkerWindow();
    if (!worker['activeMultishareWindow']) {
      worker['activeMultishareWindow'] = Wix.Utils.getCompId();
    }
  }

  isActiveIframe() {
    return utils.getWorkerWindow()['activeMultishareWindow'] === Wix.Utils.getCompId();
  }

  hideMultishareBar() {
    if (utils.isDev()) {
      console.log('Hiding multishare bar', this.isPositionSet, window);
    }
    this.toggleMultishareBar(false);
  }

  toggleMultishareBar(show) {
    if(show && this.isActiveIframe()) {
      var height = this.itemHeight + 58;
      if (AWIX && utils.isSite()) {
        AWIX.setWidgetFixedOnBottom(Wix.Utils.getCompId(), true, height * utils.getViewportScaleRatio());
        AWIX.setWidgetCss(Wix.Utils.getCompId(), {
          display: 'block',
          visibility: 'visible',
        });
      }
    } else {
      if (AWIX) {
        // AWIX.setWidgetFixedOnBottom(Wix.Utils.getCompId(), true, 0);
        AWIX.setWidgetCss(Wix.Utils.getCompId(), {
          display: 'none',
          visibility: 'hidden',
          position: 'fixed',
          overflow: 'hidden',
          top: 'auto',
          bottom: '-9999px',
          width: 0,
          height: 0,
          minWidth: 0,
          minHeight: 0
        });
      }
    }
  }

  openDialog(items) {
    try {
      utils.getWorkerWindow()['multishareItems'] = items;
      Wix.openModal(utils.getUrlPrefix() + 'sharedialog.html', 610, 570, () => {}, Wix.Theme.BARE);
      // this.clearMultishareItems();
    } catch (e) {
      console.warn('Error openning dialog', e);
    }
  }

  resetWidgetPosition() {

    if (this.setWidgetPositionInterval) {
      clearInterval(this.setWidgetPositionInterval);
    }
    this.setWidgetPositionInterval = setInterval(() => {
      this.setWidgetPositionIfNeeded();
    }, 1000);

    this.maxPositionSets = 5; //used to make sure the multishare does not try to reposition itself endlessly

    this.isPositionSet = false;

    if (utils.isDev()) {
      console.count('MULTISHARE - reseting widget position');
    }
  }

  setWidgetPositionIfNeeded() {

    if (this.maxPositionSets > 0 && this.isPositionSet !== true && (typeof AWIX != 'undefined')) {
      this.hideMultishareBar();
      this.maxPositionSets -= 1;
      this.isPositionSet = (window.screenY <= 0);
      if (utils.isDev()) {
        console.log('MULTISHARE - setting isPositionSet', this.isPositionSet, window.screenY);
      }
      if ((this.isPositionSet) && this.setWidgetPositionInterval) {
        if (utils.isDev()) {
          console.log('MULTISHARE - removing setWidgetPosition interval');
        }
        clearInterval(this.setWidgetPositionInterval);
      }
    } else if (this.maxPositionSets <= 0) {
      console.warn('MULTISHARE - max positioning retries reached', window.screenY);
      if (this.setWidgetPositionInterval) {
        clearInterval(this.setWidgetPositionInterval);
      }
    } else if (typeof AWIX == 'undefined') {
      console.warn('MULTISHARE - AWIX is not defined');
      //wait until the AWIX is loaded
    } else {
      if (utils.isDev()) {
        console.log('MULTISHARE - widget position set', this.isPositionSet, typeof AWIX);
      }
      if (this.setWidgetPositionInterval) {
        clearInterval(this.setWidgetPositionInterval);
      }
    }
  }

  scroll(direction) {
    var scroller = $('.sharer-items');
    var curScroll = scroller.scrollLeft();
    if (direction != 0) {
      scroller.animate({
        scrollLeft: (curScroll + 100 * direction)
      }, 200, () => {
        this.showArrowsIfNeeded();
      });
    }
  }

  showArrowsIfNeeded() {

    var scroller = $('.sharer-items');

    if (scroller.length < 1) {
      return;
    }

    var innerWidth = scroller[0].scrollWidth;
    var outerWidth = scroller.width();
    var scrollLength = innerWidth - outerWidth;

    var leftArrow = $('.sharer-arrow-back');
    var rightArrow = $('.sharer-arrow-next');

    if (scrollLength <= 0) {
      //no scroll is needed
      leftArrow.hide();
      rightArrow.hide();
    } else {
      var scrollPos = scroller.scrollLeft();

      if (scrollPos == 0) {
        //no left arrow needed
        leftArrow.hide();
        rightArrow.show();
      } else if (scrollPos == scrollLength) {
        //no right arrow is needed
        leftArrow.show();
        rightArrow.hide();
      } else {
        //both arrows are needed
        leftArrow.show();
        rightArrow.show();
      }
    }
  }
  //------------------------------------------| REACT |-------------------------------------------//

  componentDidMount() {
    utils.markWidgetInSite('multishare_widget');
    utils.fixViewport('multishare');
    window.addEventListener('orientationchange', utils.fixViewport.bind(utils, 'multishare - orientation'));

    //add events that may trigger a reposition by the editor and trigger the AWIX api to fix it
    Wix.addEventListener(Wix.Events.STYLE_PARAMS_CHANGE, this.resetWidgetPosition);
    Wix.addEventListener(Wix.Events.SETTINGS_UPDATED, this.resetWidgetPosition);
    Wix.addEventListener(Wix.Events.THEME_CHANGE, this.resetWidgetPosition);
    Wix.addEventListener(Wix.Events.EDIT_MODE_CHANGE, this.resetWidgetPosition);
    Wix.addEventListener(Wix.Events.SCROLL, this.resetWidgetPosition);
    window.addEventListener('scroll', this.resetWidgetPosition);
    window.addEventListener('resize', this.resetWidgetPosition);
    window.addEventListener('orientationchange', this.resetWidgetPosition);

    this.setActiveIframe();
    this.resetWidgetPosition();
    this.initPubsubListener();

  }

  componentWillUnmount() {
    window.removeEventListener('orientationchange', utils.fixViewport.bind(utils, 'multishare - orientation'));
    this.removePubsubListener();
  }

  componentDidUpdate() {
    this.setWidgetPositionIfNeeded();
    this.showArrowsIfNeeded();
  }

  //------------------------------------------| RENDER |-------------------------------------------//

  render() {
    var navArrows = [
      <div
        className={"sharer-arrow-back sharer-arrows-container prev "}
        style={{display: 'none'}}
        onClick={() => this.scroll(-1)}
        key="sharer-arrow-back"
      >
        <svg version="1.1" x="0px" y="0px" viewBox="0 0 21 41"
             className={"sharer-arrows"}
        >
          <polygon points="20.3,40.8 0,20.5 20.3,0.2 21,0.9 1.3,20.5 21,40.1 "/>
        </svg>
      </div>,
      <div
        className={"sharer-arrow-next sharer-arrows-container next"}
        style={{display: 'none'}}
        onClick={() => this.scroll(1)}
        key="sharer-arrow-next"
      >
        <svg version="1.1" x="0px" y="0px" viewBox="0 0 21 41"
             className={"sharer-arrows next "}
        >
          <polygon points="20.3,40.8 0,20.5 20.3,0.2 21,0.9 1.3,20.5 21,40.1 "/>
        </svg>
      </div>
    ];


    return this.state.items.length !== 0 && (
        <div className={`sharer-container ${utils.isMobile() ? 'mobile' : ''}`}>
          <div className="sharer-placeholder"/>
          <div className="sharer-floater" style={{
            top: this.state.top
          }}>
            <div className="sharer-wrapper">
              {navArrows[0]}
              <i className="sharer-x progallery-svg-font-icons-x"
                 onClick={this.clearMultishareItems}/>
              <div className="sharer-icons">
                {this.shareButtons}
              </div>
              <div className="sharer-items hide-scrollbars">
                {this.state.itemsDOM}
              </div>
              {navArrows[1]}
              <div className="clear"></div>
            </div>
          </div>
        </div>
      );

  }
}

function mapStateToProps(state) {
  return state.multishare;
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MultishareContainer);




// WEBPACK FOOTER //
// ./components/multishare/multishareContainer.js